import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { EDIT } from "const"
import { MtProjectGroup } from "server/models"
import { hasAccess } from "client/utils"
import { PRM_ACCOUNT_SETTINGS, StoreType, addModal } from "client/store"
import {
    Link,
    Default,
    TableColumn,
} from "client/components"

import EditDefaultGroup from "./edit"

const Columns = () => {
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editAccess = hasAccess(PRM_ACCOUNT_SETTINGS, EDIT)
    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            formatter: (group: MtProjectGroup) => group.groupId,
        },
        {
            field: "name",
            header: lang.name,
            cellMinWidth: "100px",
            formatter: (group: MtProjectGroup) => (editAccess
                ? (
                    <>
                        <Link
                            href="/#"
                            onClick={() => dispatch(addModal({
                                key: "editProjectGroup",
                                content: <EditDefaultGroup groupData={group} />,
                            }))}
                        >
                            {group.name}
                        </Link>
                        {group.default && <Default marginLeft />}
                    </>
                ) : (
                    <>
                        {group.name}
                        {group.default && <Default marginLeft />}
                    </>
                )),
        },
        {
            field: "description",
            header: lang.description,
            cellMinWidth: "200px",
            cellMaxWidth: "400px",
        },
    ]

    if (editAccess) {
        columns.unshift({
            field: "sort",
            centerAlign: true,
        })
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: (group: MtProjectGroup) => !(group.default && userData.accountId !== 1),
        })
    }

    return columns
}
export default Columns
